export enum Colors {
  None = 'none',
  Warn = 'warn',
  Accent = 'accent',
  Primary = 'primary',
}
